/**
 * Prevent focusable elements inside aria-hidden Tiny Slider slides from receiving keyboard focus.
 */
(function() {
	'use strict';

	var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

	function manageHiddenSlideFocus( slider ) {
		if ( ! slider || ! slider.getInfo ) {
			return;
		}

		var slideItems = slider.getInfo().slideItems;

		if ( ! slideItems || ! slideItems.length ) {
			return;
		}

		Array.prototype.forEach.call( slideItems, function( slide ) {
			var hidden = slide.getAttribute( 'aria-hidden' ) === 'true';

			slide.querySelectorAll( FOCUSABLE ).forEach( function( el ) {
				if ( hidden ) {
					if ( ! el.hasAttribute( 'data-tns-tabindex' ) ) {
						el.setAttribute( 'data-tns-tabindex', el.getAttribute( 'tabindex' ) || '' );
					}
					el.setAttribute( 'tabindex', '-1' );
				} else if ( el.hasAttribute( 'data-tns-tabindex' ) ) {
					var prev = el.getAttribute( 'data-tns-tabindex' );

					if ( prev === '' ) {
						el.removeAttribute( 'tabindex' );
					} else {
						el.setAttribute( 'tabindex', prev );
					}

					el.removeAttribute( 'data-tns-tabindex' );
				}
			} );
		} );
	}

	window.initTnsAccessibility = function( slider ) {
		if ( ! slider || ! slider.events ) {
			return;
		}

		slider.events.on( 'indexChanged', function() {
			manageHiddenSlideFocus( slider );
		} );

		manageHiddenSlideFocus( slider );
	};
}() );
